import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { SvgIcon } from "@mui/material";
export default function NavigateDownIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 92 128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 51l7-7 38 38 38-38 7 7-45 45z"
  }));
}
NavigateDownIcon.defaultProps = {
  fontSize: "inherit"
};